export const PLAYER_EDIT_MODAL_LAYOUT = {
  width: 760,
  height: 400,
  strokeWidth: 3,
  nameInputWidth: 400,
  nameInputHeight: 46,
  bindingBoxWidth: 220,
  bindingBoxHeight: 50,
  rebindButtonWidth: 180,
} as const;
